import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Dialog from '@mui/material/Dialog';
import SlideTransition from '@/components/SlideTransition';
import { classes, styles } from '../utils';

export interface PaletteShellProps {
  className?: string;
  children: ReactNode;
  onClose: () => void;
}

export default function PaletteShell({
  className,
  children,
  onClose,
}: PaletteShellProps) {
  return (
    <Dialog
      open
      keepMounted
      disableRestoreFocus
      maxWidth={false}
      PaperProps={{ className: twMerge(classes.paper, className) }}
      slotProps={{ backdrop: { sx: styles.backdrop } }}
      TransitionComponent={SlideTransition}
      onClose={onClose}>
      {children}
    </Dialog>
  );
}
